import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DeviceMasterService = /** @class */ (function () {
    function DeviceMasterService(http) {
        this.http = http;
        this.details = null;
        this.action = null;
    }
    DeviceMasterService.prototype.saveDeviceData = function (data) {
        var payload = data;
        console.log('PAYLOAD:', payload);
        return this.http.post('addDevice', payload);
    };
    DeviceMasterService.prototype.getDeviceData = function (deviceType) {
        return this.http.get('getAllDevice?deviceType=' + deviceType);
    };
    DeviceMasterService.prototype.getEMSDeviceId = function (data) {
        return this.http.get('getEMSDeviceId?id=' + data);
    };
    DeviceMasterService.prototype.updateDeviceData = function (data) {
        var payload = data;
        console.log('PAYLOAD:', payload);
        return this.http.post('updateDevice', payload);
    };
    DeviceMasterService.prototype.getDeviceById = function (data) {
        // getUserList?roleid=${data.roleid}&userid=${data.userid}
        // let payload = data;
        return this.http.get("getDeviceById?deletedFlag=" + data.deletedFlag + "&deviceId=" + data.deviceId);
    };
    DeviceMasterService.prototype.downloadCrc = function (deviceId) {
        return this.http.get('crc?deviceid=' + deviceId, { responseType: 'blob' });
    };
    DeviceMasterService.prototype.downloadFrimware = function (deviceId) {
        return this.http.get('Firmware?deviceid=' + deviceId, { responseType: 'blob' });
    };
    DeviceMasterService.prototype.deleteData = function (deviceId) {
        var payload = deviceId;
        return this.http.post('deleteDevice', payload);
    };
    DeviceMasterService.prototype.getLastdatatransformer = function (deviceid) {
        return this.http.post('getLastdatatransformer?deviceType', deviceid);
    };
    DeviceMasterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeviceMasterService_Factory() { return new DeviceMasterService(i0.ɵɵinject(i1.HttpClient)); }, token: DeviceMasterService, providedIn: "root" });
    return DeviceMasterService;
}());
export { DeviceMasterService };
